<template>
  <button id="info_apelido" v-show="false" @click="showApelidoHelp">Help apelido</button>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import sweetAlert from "./controller/sweetAlert";

export default {
  mixins: [sweetAlert],

  components: { Loading },

  props: ["usuarios"],

  data() {
    return {};
  },

  mounted() {
    console.log("HELP APELIDO");
  },

  methods: {
    showApelidoHelp() {
      this.$swal.fire({
        icon: "info",
        title: "Apelido",
        padding: "1.5em",
        text: "  O apelido é um nome curto para ser identificado dentro do auditório quando der lance.",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.float {
  position: fixed;
  width: 80px;
  height: 80px;
  bottom: 10px;
  right: 40px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 12px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
}

.my-float {
  margin-top: 16px;
}

form {
  display: grid;
  padding: 1em;
  background: #f9f9f9;
  border: 1px solid #c1c1c1;
  margin: 2rem auto 0 auto;
  max-width: 500px;
  padding: 1em;
}

form input {
  background: #fff;
  border: 1px solid #9c9c9c;
}

form button {
  background-color: blue;
  color: white;
  font-size: 1em;
  font-weight: bold;
  padding: 0.7em;
  width: 100%;
  border: 0;
}

form button:hover {
  background: gold;
  color: black;
}

label {
  padding: 0.5em 0.5em 0.5em 0;
}

input {
  padding: 0.7em;
  margin-bottom: 0.5rem;
}

input:focus {
  outline: 3px solid gold;
}

@media (min-width: 400px) {
  form {
    grid-template-columns: 150px 1fr;
    grid-gap: 16px;
  }

  label {
    text-align: right;
    grid-column: 1 / 2;
  }

  input,
  button {
    grid-column: 2 / 3;
  }
}

button {
  background-color: blue;
  color: white;
  font-weight: bold;
  border-radius: 10px;
}

button:focus {
  outline: none;
}

form button:disabled,
form button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

section {
  margin: 10px 0;
}

img {
  max-width: 300px;
  height: auto;
}
</style>
